import React, { useState, useEffect } from 'react';
import Card from '../../components/Card/Card.jsx';
import CardBody from '../../components/Card/CardBody.jsx';
import CardHeader from '../../components/Card/CardHeader';
import withStyles from '@material-ui/core/styles/withStyles';
import pageStyle from '../../components/Page/PageStyle';
import NavPath from '../../components/NavPath';
import CardDeuda from './CardDeuda.js';

const styles = (theme) => ({
  ...pageStyle(theme),
});

const NodoDeuda = (props) => {
  const { classes, datos } = props;
  const [deuda, setDeuda] = useState([]);
  const [importeDeuda, setImporteDeuda] = useState(0);
  const [camino, setCamino] = useState([]);

  useEffect(() => {
    handleSeleccion(datos);
  }, []);

  const retornarDeuda = (nodo, newDeudas) => {
    if (nodo.tipo.detalle !== undefined && nodo.tipo.detalle === 'det') {
      nodo.detalle.forEach((det) => newDeudas.push(det));
    }
    if (nodo.detalle !== undefined && nodo.tipo.detalle === 'res') {
      nodo.detalle.forEach((det) => newDeudas = retornarDeuda(det, newDeudas));
    }
    return newDeudas;
  };

  const sumarImportesDeudas = (deudas) => {
    let total = 0;
    deudas.forEach((deuda) => total += deuda.total);
    return total;
  };

  /* Al seleccionar un nodo que tiene un unico camino hacia su hoja,
		 Lo recorre agregando los nodos intermedios al camino.
	 */
  const push = (newCamino, nodo) => {
    newCamino.push(nodo);
    if (nodo.detalle.length === 1 && nodo.tipo.detalle === 'res') {
      newCamino = push(newCamino, nodo.detalle[0]);
    }
    return newCamino;
  };

  const handleSeleccion = (nodoSelected) => {
    document
      .getElementById("mainScrollAnchor")
      .scrollTo({ top: 0, behavior: "smooth" });

    let newCamino = [...camino],
      newImporteDeuda = importeDeuda;

    newCamino = push(newCamino, nodoSelected);
    let newDeuda = retornarDeuda(newCamino[newCamino.length - 1], []);
    newCamino.length === 1
      ? (newImporteDeuda = nodoSelected.total)
      : (newImporteDeuda = sumarImportesDeudas(newDeuda));

    setImporteDeuda(newImporteDeuda);
    setDeuda(newDeuda);
    setCamino(newCamino);
  };

  const handleOnClickIniPath = (path) => {
    setCamino([]);
  };

  const handleOnClickPath = (path) => {
    const item = camino.filter(
      (item) => item.id === path.item.id
    )[0];
    const itemIndex = camino.indexOf(item);
    let newCamino = camino.slice(0, itemIndex + 1),
      newDeuda = retornarDeuda(newCamino[newCamino.length - 1], []),
      newImporteDeuda = importeDeuda;
    newCamino.length === 1
      ? (newImporteDeuda = newCamino[0].total)
      : (newImporteDeuda = sumarImportesDeudas(newDeuda));
    setImporteDeuda(newImporteDeuda);
    setDeuda(newDeuda);
    setCamino(newCamino);
  };

  const handleCheckBox = (item) => {
    let newDeuda = deuda.includes(item) ? deuda.filter((deuda) => deuda.id !== item.id)
      : [...deuda, item],
      newImporteDeuda = sumarImportesDeudas(newDeuda);

    setDeuda(newDeuda);
    setImporteDeuda(newImporteDeuda);
  };

  const handleCheckBoxTodos = (checkedTodos) => {
    const nodoSelected = camino[camino.length - 1];
    let newCamino = [...camino],
      newDeuda = checkedTodos ? retornarDeuda(newCamino[newCamino.length - 1], [])
      : [],
      newImporteDeuda = newCamino.length === 1 ? nodoSelected.total
      : sumarImportesDeudas(newDeuda);
    setDeuda(newDeuda);
    setImporteDeuda(newImporteDeuda);
    setCamino(newCamino);
  };

  const handleOnClickPagar = () => {
    let deudaActual = deuda.length === 0 ? [props.datos] : deuda;
    props.handleOnClickPagar(deudaActual, importeDeuda);
  };

  return (
    <div>
      <Card className={classes.card}>
        <CardHeader>
          {datos !== undefined && (
            <NavPath
              handleOnClick={handleOnClickPath}
              handleOnClickIni={handleOnClickIniPath}
              paths={camino.map((item) => {
                return { texto: item.descripcion1, item };
              })}
            />
          )}
        </CardHeader>
        <CardBody>
          <div>
            <CardDeuda
              data={camino[camino.length - 1]}
              importeDeuda={importeDeuda}
              deuda={deuda}
              handleSeleccion={handleSeleccion}
              handleOnClickPagar={handleOnClickPagar}
              handleCheckBox={handleCheckBox}
              handleCheckBoxTodos={handleCheckBoxTodos}
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default withStyles(styles)(NodoDeuda);
